import ProjectInitializationWizardStore from "./ProjectInitialization/ProjectInitializationWizardStore";
import DailyProductionLogWizardStore from "./DailyProductionLog/DailyProductionLogWizardStore";
import QCInspectionWizardStore from "./QCInspection/QCInspectionWizardStore";
import YardInventoryWizardStore from "./YardInventory/YardInventoryWizardStore";
import ShipmentPlanningWizardStore from "./ShipmentPlanning/ShipmentPlanningWizardStore";
import EngineeringDataWizardStore from "./EngineeringData/EngineeringDataWizardStore";
import ProductionScheduleWizardStore from "./ProductionSchedule/ProductionScheduleWizardStore";
import NCRWizardStore from "./NCR/NCRWizardStore";

// New workflow stores - Updated to use correct implementations
import ProjectBidProposalWizardStore from "./Estimating/ProjectBidProposal/ProjectBidProposalWizardStore";
import SubmittalPackageWizardStore from "./Engineering/SubmittalPackage/SubmittalPackageWizardStore";
import RFIManagementWizardStore from "./Engineering/RFIManagement/RFIManagementWizardStore";
import InventoryAdjustmentsWizardStore from "./InventoryAdjustments/InventoryAdjustmentsWizardStore";
import AddRawMaterialsWizardStore from "./AddRawMaterials/AddRawMaterialsWizardStore";
import PORequisitionWizardStore from "./PORequisition/PORequisitionWizardStore";
import LaborTimeTrackingWizardStore from "./LaborTimeTracking/LaborTimeTrackingWizardStore";
import EquipmentMaintenanceWizardStore from "./EquipmentMaintenance/EquipmentMaintenanceWizardStore";
import ToolCalibrationWizardStore from "./QualityControl/ToolCalibration/ToolCalibrationWizardStore";
import PieceRemediationWizardStore from "./YardManagement/PieceRemediation/PieceRemediationWizardStore";
import LoadStagingWizardStore from "./YardManagement/LoadStaging/LoadStagingWizardStore";
import YardAuditWizardStore from "./YardManagement/YardAudit/YardAuditWizardStore";
import FleetDriverManagementWizardStore from "./FleetDriverManagement/FleetDriverManagementWizardStore";
import DeliveryConfirmationWizardStore from "./Dispatch/DeliveryConfirmation/DeliveryConfirmationWizardStore";
import InstallationTrackingWizardStore from "./InstallationTracking/InstallationTrackingWizardStore";
import FieldIssueWizardStore from "./FieldOperations/FieldIssue/FieldIssueWizardStore";
import WarrantyClaimWizardStore from "./WarrantyClaim/WarrantyClaimWizardStore";
import SafetyComplianceWizardStore from "./FieldOperations/SafetyCompliance/SafetyComplianceWizardStore";
import ChangeOrderWizardStore from "./ChangeOrder/ChangeOrderWizardStore";
import ProjectBillingWizardStore from "./ProjectBilling/ProjectBillingWizardStore";
import CustomerCommunicationWizardStore from "./ProjectManagement/CustomerCommunication/CustomerCommunicationWizardStore";
import ReportBuilderWizardStore from "./Analytics/ReportBuilder/ReportBuilderWizardStore";

const workflowsStoreList = [
  // Existing stores
  { name: "projectInitializationWizardStore", store: ProjectInitializationWizardStore },
  { name: "dailyProductionLogWizardStore", store: DailyProductionLogWizardStore },
  { name: "qcInspectionWizardStore", store: QCInspectionWizardStore },
  { name: "yardInventoryWizardStore", store: YardInventoryWizardStore },
  { name: "shipmentPlanningWizardStore", store: ShipmentPlanningWizardStore },
  { name: "engineeringDataWizardStore", store: EngineeringDataWizardStore },
  { name: "productionScheduleWizardStore", store: ProductionScheduleWizardStore },
  { name: "ncrWizardStore", store: NCRWizardStore },

  // New workflow stores
  { name: "projectBidProposalWizardStore", store: ProjectBidProposalWizardStore },
  { name: "submittalPackageWizardStore", store: SubmittalPackageWizardStore },
  { name: "rfiManagementWizardStore", store: RFIManagementWizardStore },
  { name: "inventoryAdjustmentsWizardStore", store: InventoryAdjustmentsWizardStore },
  { name: "addRawMaterialsWizardStore", store: AddRawMaterialsWizardStore },
  { name: "poRequisitionWizardStore", store: PORequisitionWizardStore },
  { name: "laborTimeTrackingWizardStore", store: LaborTimeTrackingWizardStore },
  { name: "equipmentMaintenanceWizardStore", store: EquipmentMaintenanceWizardStore },
  { name: "toolCalibrationWizardStore", store: ToolCalibrationWizardStore },
  { name: "pieceRemediationWizardStore", store: PieceRemediationWizardStore },
  { name: "loadStagingWizardStore", store: LoadStagingWizardStore },
  { name: "yardAuditWizardStore", store: YardAuditWizardStore },
  { name: "fleetDriverManagementWizardStore", store: FleetDriverManagementWizardStore },
  { name: "deliveryConfirmationWizardStore", store: DeliveryConfirmationWizardStore },
  { name: "installationTrackingWizardStore", store: InstallationTrackingWizardStore },
  { name: "fieldIssueWizardStore", store: FieldIssueWizardStore },
  { name: "warrantyClaimWizardStore", store: WarrantyClaimWizardStore },
  { name: "safetyComplianceWizardStore", store: SafetyComplianceWizardStore },
  { name: "changeOrderWizardStore", store: ChangeOrderWizardStore },
  { name: "projectBillingWizardStore", store: ProjectBillingWizardStore },
  { name: "customerCommunicationWizardStore", store: CustomerCommunicationWizardStore },
  { name: "reportBuilderWizardStore", store: ReportBuilderWizardStore },
];

export default workflowsStoreList;